export default {
	SidebarOpenedKey: 'sidebarOpened',
	LangKey: 'lang',
	ComponentSizeKey: 'componentSize',
	TokenKey: 'maToken',
	RefreshTokenKey: 'maRefreshToken',
	ThemeKey: 'theme',
	TenantId: 'tenantId',
	UserInfoKey: 'userInfo',
	DictListKey: 'dictList',
	AuthorityListKey: 'authorityList',
	ShowPlatKey: 'showPlat'
}
